import * as Yup from 'yup';
import i18n from 'i18n';

const passwordRequirementsMessage = i18n.t('Forms.Validation.PasswordRequirements', {
    format: i18n.t('Forms.Validation.PasswordInstruction'),
});

const vendorLoginFormSchemaWrapper = () => {
    const vendorLoginFormSchema = Yup.object()
        .shape({
            Emailaddress: Yup.string()
                .email(i18n.t('Forms.Validation.ValidEmail'))
                .required(i18n.t('Forms.Validation.EmailRequired')),
            Password: Yup.string().required(i18n.t('Forms.Validation.PasswordRequired')),
            EnterOTP: Yup.string()
                .required(i18n.t('Forms.Validation.OTPRequired'))
                .matches(/^\d*$/, 'OTP must contain only numbers')
                .max(6, 'OTP must be only 6 characters'),
            Enterpassword: Yup.string()
                .required(i18n.t('Forms.Validation.PasswordRequired'))
                .min(8, passwordRequirementsMessage)
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s])[A-Za-z\d\S]{8,}$/,
                    passwordRequirementsMessage
                ),
            Confirmpassword: Yup.string()
                .required(i18n.t('Forms.Validation.ConfirmPasswordRequied'))
                .oneOf([Yup.ref('Enterpassword')], i18n.t('Forms.Validation.PasswordsMustMatch')),
            Firstname: Yup.string()
                .max(
                    120,
                    i18n.t('Forms.Validation.CannotExceedCharacterLimit', {
                        characterLimit: '120',
                    })
                )
                .matches(
                    /^[A-Za-z\s]*$/,
                    i18n.t('Name should not contain any special characters or numbers', {
                        field: i18n.t('Forms.Labels.Firstname'),
                    })
                )
                .required(i18n.t('Forms.Validation.NameRequired')),
            Lastname: Yup.string()
                .max(
                    120,
                    i18n.t('Forms.Validation.CannotExceedCharacterLimit', {
                        characterLimit: '120',
                    })
                )
                .matches(
                    /^[A-Za-z\s]*$/,
                    i18n.t('Name should not contain any special characters or numbers', {
                        field: i18n.t('Forms.Labels.Firstname'),
                    })
                )
                .required(i18n.t('Forms.Validation.NameRequired')),
            Phonenumber: Yup.string().required(i18n.t('Forms.Validation.PhonenumRequired')),
        })
        .required();

    return vendorLoginFormSchema;
};

export { vendorLoginFormSchemaWrapper };
